<template>
  <div class="device-param-container">
    <div class="status-overview" v-if="paramList.length > 0">
      <div class="status-card">
        <div class="status-icon" :style="{ background: autoMode === '自动' ? 'rgba(82,196,26,0.2)' : 'rgba(250,173,20,0.2)' }">
          <a-icon :type="autoMode === '自动' ? 'sync' : 'tool'" :style="{ color: autoMode === '自动' ? '#52c41a' : '#faad14', fontSize: '22px' }" />
        </div>
        <div class="status-info">
          <div class="status-label">手自动状态</div>
          <div class="status-value" :style="{ color: autoMode === '自动' ? '#52c41a' : '#faad14' }">{{ autoMode }}</div>
        </div>
      </div>
      <div class="status-card">
        <div class="status-icon" style="background: rgba(24,144,255,0.2)">
          <i class="iconfont icon-famen" style="color: #1890ff; font-size: 34px;"></i>
        </div>
        <div class="status-info">
          <div class="status-label">当前阀门开度</div>
          <div class="status-value" style="color: #69c0ff">{{ valveOpening }}<span class="status-unit">%</span></div>
        </div>
      </div>
      <div class="status-card">
        <div class="status-icon" style="background: rgba(0,255,255,0.15)">
          <a-icon type="dashboard" :style="{ color: '#0ff', fontSize: '22px' }" />
        </div>
        <div class="status-info">
          <div class="status-label">累计流量表底</div>
          <div class="status-value" style="color: #0ff">{{ flowBase }}<span class="status-unit">m³</span></div>
        </div>
      </div>
      <div class="status-card refresh-card" @click="loadParams">
        <div class="status-icon" style="background: rgba(24,144,255,0.15)">
          <a-icon type="sync" :spin="loading" :style="{ color: '#1890ff', fontSize: '22px' }" />
        </div>
        <div class="status-info">
          <div class="status-value" style="color: #1890ff; font-size: 1rem; font-family: inherit;">{{ loading ? '刷新中...' : '刷新参数' }}</div>
        </div>
      </div>
    </div>
    <a-table
      :columns="columns"
      :dataSource="paramList"
      :loading="loading"
      :pagination="false"
      rowKey="Name"
      size="middle"
      class="param-table"
    >
      <span slot="value" slot-scope="text" class="value-text">{{ text }}</span>
      <span slot="unit" slot-scope="text" class="unit-text">{{ text }}</span>
      <template slot="setting" slot-scope="text, record">
        <a-input
          v-model="record.editValue"
          placeholder="输入新值"
          size="small"
          style="width: 130px;"
          @pressEnter="confirmSet(record)"
          allowClear
        />
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm
          :title="`确认将「${record.Name}」设置为 ${record.editValue} ？`"
          @confirm="setParam(record)"
          okText="确认"
          cancelText="取消"
          :disabled="!record.editValue && record.editValue !== '0'"
        >
          <a-button
            type="primary"
            size="small"
            :loading="record.setting"
            :disabled="!record.editValue && record.editValue !== '0'"
          >下发</a-button>
        </a-popconfirm>
      </template>
    </a-table>
    <div v-if="!loading && paramList.length === 0" class="no-data">
      <a-empty description="暂无设备参数" />
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'DeviceParam',
  props: {
    siteDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      paramList: [],
      columns: [
        { title: '参数名称', dataIndex: 'Name', width: 160, align: 'center' },
        { title: '当前值', dataIndex: 'Value', width: 120, align: 'center', scopedSlots: { customRender: 'value' } },
        { title: '单位/说明', dataIndex: 'Unit', width: 160, align: 'center', scopedSlots: { customRender: 'unit' } },
        { title: '设置值', width: 160, align: 'center', scopedSlots: { customRender: 'setting' } },
        { title: '操作', width: 100, align: 'center', scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    mn() {
      return this.siteDetail ? this.siteDetail.mn : ''
    },
    autoMode() {
      const item = this.paramList.find(p => p.Name === '手自动')
      if (!item) return '--'
      return item.Value === '0' ? '自动' : '手动'
    },
    valveOpening() {
      const item = this.paramList.find(p => p.Name === '阀门开度设定值')
      return item ? item.Value : '--'
    },
    flowBase() {
      const item = this.paramList.find(p => p.Name === '累计流量表底')
      return item ? item.Value : '--'
    }
  },
  watch: {
    mn: {
      handler(val) {
        if (val) this.loadParams()
      },
      immediate: true
    }
  },
  methods: {
    loadParams() {
      if (!this.mn) return
      this.loading = true
      getAction('/online/env/api/deviceParam/list', { mn: this.mn })
        .then(res => {
          if (res.success && res.result) {
            this.paramList = res.result.map(item => ({
              ...item,
              editValue: '',
              setting: false
            }))
          } else {
            this.$message.error(res.message || '获取设备参数失败')
            this.paramList = []
          }
        })
        .catch(() => {
          this.$message.error('获取设备参数异常')
          this.paramList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmSet(record) {
      if (!record.editValue && record.editValue !== '0') return
      this.$confirm({
        title: '确认设置',
        content: `确认将「${record.Name}」设置为 ${record.editValue} ？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => this.setParam(record)
      })
    },
    setParam(record) {
      if (!record.editValue && record.editValue !== '0') {
        this.$message.warning('请输入设置值')
        return
      }
      record.setting = true
      const url = `/online/env/api/deviceParam/set?mn=${encodeURIComponent(this.mn)}&paramName=${encodeURIComponent(record.Name)}&paramValue=${encodeURIComponent(record.editValue)}`
      postAction(url)
        .then(res => {
          if (res.success) {
            this.$message.success(`「${record.Name}」设置成功`)
            record.Value = record.editValue
            record.editValue = ''
          } else {
            this.$message.error(res.message || '参数设置失败')
          }
        })
        .catch(() => {
          this.$message.error('参数设置异常')
        })
        .finally(() => {
          record.setting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-param-container {
  padding: 15px 20px;
  height: 100%;
}


.status-overview {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;

  .status-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: rgba(21, 52, 107, 0.8);
    border: 1px solid rgba(24, 144, 255, 0.3);
    border-radius: 8px;
    transition: border-color 0.3s;

    &:hover {
      border-color: rgba(24, 144, 255, 0.6);
    }
  }

  .refresh-card {
    cursor: pointer;
    flex: 0 0 auto;
    padding: 12px 20px;

    &:active {
      background: rgba(24, 144, 255, 0.15);
    }
  }

  .status-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .status-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .status-label {
    font-size: 0.75rem;
    color: #8ec8f0;
  }

  .status-value {
    font-size: 1.8rem;
    font-weight: bold;
    font-family: 'UnidreamLED', monospace;
    line-height: 1;
  }

  .status-unit {
    font-size: 0.7rem;
    color: #8ec8f0;
    margin-left: 3px;
    font-family: inherit;
  }
}

.param-table {
  ::v-deep .ant-table {
    background: transparent;
    color: #ddd;
    font-size: 0.85rem;
  }

  ::v-deep .ant-table-thead > tr > th {
    background: rgba(24, 144, 255, 0.15);
    color: #0ff;
    border-bottom: 1px solid rgba(24, 144, 255, 0.4);
    font-weight: bold;
    padding: 10px 16px;
  }

  ::v-deep .ant-table-tbody > tr > td {
    background: transparent;
    border-bottom: 1px solid rgba(44, 88, 166, 0.4);
    color: #ddd;
    padding: 12px 16px;
  }

  ::v-deep .ant-table-tbody > tr:hover > td {
    background: rgba(24, 144, 255, 0.08);
  }

  ::v-deep .ant-table-placeholder {
    background: transparent;
    color: #999;
  }

  ::v-deep .ant-input {
    background: rgba(0, 0, 0, 0.3);
    border-color: #1890ff;
    color: #fff;

    &::placeholder {
      color: #666;
    }
  }

  ::v-deep .ant-table-content {
    overflow-x: auto;
  }
}

.value-text {
  color: #0ff;
  font-weight: bold;
  font-size: 0.9rem;
}

.unit-text {
  color: #8ec8f0;
  font-size: 0.8rem;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #666;

  ::v-deep .ant-empty-description {
    color: #666;
  }
}
</style>
